import * as React from 'react';
import { Link } from 'react-router-dom';
import Button from './modules/components/button';
import Typography from './modules/components/typography';
import ProductHeroLayout from './modules/product_hero_layout';
import { SectionHeading } from './section_blocks';
import withRoot from './with_root';

const backgroundImage =
  'https://images.pexels.com/photos/590041/pexels-photo-590041.jpeg?auto=compress&cs=tinysrgb&w=1600';

function ProductHero() {
  return (
    <ProductHeroLayout
      sxBackground={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundColor: '#1E2536',
        backgroundPosition: 'center'
      }}
    >
      <img style={{ display: 'none' }} src={backgroundImage} alt="Personal Finance Toolkit planning session" />
      <SectionHeading
        eyebrow="Personal Finance Toolkit"
        title="Build stronger money habits with tools you can trust"
        subtitle="Forecast your emergency fund, model compound growth, and learn the fundamentals with guidance designed for real life."
      />
      <Button
        color="secondary"
        variant="contained"
        size="large"
        component={Link}
        to="/learning-hub"
        sx={{ minWidth: 220 }}
      >
        Explore the learning hub
      </Button>
      <Typography variant="body2" color="inherit" sx={{ mt: 2 }}>
        Plan clearly. Save confidently.
      </Typography>
    </ProductHeroLayout>
  );
}

export default withRoot(ProductHero);
